import PropTypes from 'prop-types'
import OrderList from 'shared/orders/order-list'
import { SUPPORT_EMAIL } from 'shared/constants'
import withYourOrders from './with-your-orders'

export const YourOrders = ({ hasError, orders }) => {
  return (
    <>
      {!hasError ? (
        <OrderList orders={orders} />
      ) : (
        <p>
          {`Oops! Something went wrong. We are unable to load your orders at this
            time. Please try again later or contact `}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          {` if the problem continues.`}
        </p>
      )}
    </>
  )
}

YourOrders.defaultProps = {
  hasError: false,
}

YourOrders.propTypes = {
  hasError: PropTypes.bool,
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      createdAt: PropTypes.string,
      orderItems: PropTypes.arrayOf(PropTypes.object),
      reference: PropTypes.string,
      returnWebUrl: PropTypes.string,
      statusWebUrl: PropTypes.string,
      total: PropTypes.number,
      trackingInfos: PropTypes.arrayOf(PropTypes.object),
    })
  ).isRequired,
}

export default withYourOrders(YourOrders)
